export class Indicator {
    public element: HTMLDivElement;

    constructor() {
        this.element = document.createElement("div");
        this.element.className = "indicator";
    }

    public update(index: number, count: number): void {
        if (count <= 1) {
            // this.element.innerHTML = "";
            this.active = false;
            return;
        }

        var html = "";
        for (var i = 0; i < count; ++i) {
            html += `<span class="circle ${index === i ? "active" : ""}"></span>`;
        }
        this.element.innerHTML = html;

        this.active = true;
    }

    private get active(): boolean {
        return this.element.classList.contains("active");
    }

    private set active(active: boolean) {
        this.element.classList.toggle("active", active);
    }

    public static create(index: number, count: number): string {
        
        return `<div class="indicator gallery-indicator active">${this.createInner(index, count)}</div>`;
    }

    public static createInner(index: number, count: number): string {
        if (count <= 1) {
            return "";
        }

        var html = "";
        for (var i = 0; i < count; ++i) {
            html += `<span class="circle ${index === i ? "active" : ""}"></span>`;
        }
        return html;
    }
}